import request from '@/utils/request'
import { downloadBlob } from '@/utils/helpers'
import uuid from 'uniq-id'

export default {
    getAccountBalanceHistories: async({ dispatch, commit }, params) => {
        commit('SET_LOAD', true)
        await request({
            method: 'get',
            url: 'balance-history',
            responseType: params.excel ? 'blob' : 'json',
            params: {
                leaderId: params.leader && params.leader.id,
                businessId: params.business && params.business.id,
                ...Object.select(params, ['fromDate', 'toDate', 'taxiOrderId', 'clientPhone', 'page', 'excel',
                    'column', 'direction', 'enrollmentType'
                ])
            }
        }).then(res => {
            if (res.data && res.data.accountBalanceHistories) {
                commit('SET_PAGINATION', {
                    length: res.data.totalPages,
                    page: res.data.page,
                    total: res.data.total
                })
                commit('SET_ACCOUNT_BALANCE_HISTORIES', res.data.accountBalanceHistories)
            } else if (res.data && params.excel) {
                downloadBlob(res.data, `Report_${uuid()}.xlsx`)
            }

            commit('SET_LOAD', false)
        })
    }
}
